module.exports = __webpack_public_path__ + "static/img/dingdan.dc02fa97.jpg";